// extracted by mini-css-extract-plugin
export default {"selectBox":"SWSelectBox_selectBox__UORtb"};